export const pushTrackingEvent = (name: string, value: string) => {
  if (!window._paq) return;
  window._paq.push([name, value]);
};

export const pushTagManagerEvent = (
  name: string,
  value: Record<string, any>
) => {
  if (!window._mtm) return;
  window._mtm.push({ event: name, ...value });
};
